/**
 * Accessibility-aware helper function for creating CSS transitions.
 *
 * Example: transition("opacity 0.2s ease-out");
 */
export default function transition(transition: string) {
  return `
    transition: ${transition};

    @media screen and (prefers-reduced-motion) {
      transition: none;
    }
  `;
}
